import React from "react";
import { Link } from "react-router-dom";
import success from "./res/success.png";

function Success() {
  React.useEffect(() => {
    localStorage.removeItem("cartItems");
    localStorage.removeItem("cartTotal");
  }, []);
  return (
    <div className="section">
      <div className="process-section success">
        <div className="process-img">
          <img src={success} alt="" />
        </div>
        <div style={{ textAlign: "center" }}>
          Congrats, Order Placed Successfully
        </div>
        <div className="home">
          <Link to="/">Go Home</Link>
        </div>
      </div>
    </div>
  );
}

export default Success;
